<template>
  <div class="row">
    <div class="col-12">
      <template>
        <component
          :is="component"
          :eduInfo.sync="eduInfo"
        />
      </template>
    </div>
  </div>
</template>
<script>
export default {
  name: 'education-division-env2',
  props: {
    popupParam: {
      type: Object,
      default(){
        return {
          title: '',
        }
      },
    },
  },
  data() {
    return {
      editable: true,
      eduInfo: {
        educationKindCdLarge: 'EKFC000002', // process menaul
      },
      component: null,
    };
  },

  beforeCreate() {},
  created() {},
  beforeMount() {
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  computed: {
  },
  watch: {
  },
  methods: {
    init() {
      this.component = () => import('@/pages/sop/edu/annualEducationPlan.vue');
      this.getList();
    },
    getList() {
    },
    reset() {
      Object.assign(this.$data.documentInfo, this.$options.data().documentInfo);
    },
  }
};
</script>